'use strict';

module.exports = function () {
  return this.opts.storage === 'local' ? localStorage : sessionStorage;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/computed/storage.js